module.exports = __webpack_public_path__ + "static/img/040_4.6b1134e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/040_4.jpg
// module id = ZJhe
// module chunks = 1